import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const RS: DeepPartial<AddressBook> = {
    phoneNumberPrefix: '06',
    cacheDurationV2: {
        search: 5000,
    },
};
